"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Dropdown_1 = __importDefault(require("../Dropdown"));
var typography_1 = require("../../typography");
var Link_1 = __importDefault(require("../../navigation/Link"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var TextButton_1 = __importDefault(require("../TextButton"));
var styles_1 = require("./styles");
function DropdownMenu(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, maxHeight = _a.maxHeight, zIndex = _a.zIndex, props = __rest(_a, ["items", "maxHeight", "zIndex"]);
    return (react_1.default.createElement(Dropdown_1.default, __assign({ "data-component-name": "DropdownMenu" }, props), function (_a) {
        var from = _a.from;
        return (react_1.default.createElement(styles_1.Content, { "$from": from, "$zIndex": zIndex },
            react_1.default.createElement(styles_1.Wrapper, { "$maxHeight": maxHeight }, items.map(function (item, i) {
                var _a, _b;
                return (react_1.default.createElement(TextVerticalSpacer_1.default, { key: i, level: "5" },
                    item.label && (react_1.default.createElement(typography_1.Label, { level: "2", color: "GREY_70" }, item.label)),
                    react_1.default.createElement(react_1.default.Fragment, null, (((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0
                        ? (_b = item.items) === null || _b === void 0 ? void 0 : _b.map(function (subItem, subItemI) {
                            if (subItem.href) {
                                return (react_1.default.createElement(typography_1.Body, { key: subItemI, level: "3" },
                                    react_1.default.createElement(Link_1.default, { href: subItem.href, isExternal: subItem.isExternal, newTab: subItem.newTab, color: "GREY_90", hoverColor: "BLUE_50" }, subItem.display)));
                            }
                            return (react_1.default.createElement(typography_1.Body, { level: "3", key: subItemI },
                                react_1.default.createElement(TextButton_1.default, { onClick: subItem.onClick, color: "GREY_90", hoverColor: "BLUE_50" }, subItem.display)));
                        })
                        : item.children)));
            }))));
    }));
}
exports.default = DropdownMenu;
